import { createContext, useContext } from 'react';
import { notification as antdNotification } from 'antd';
const addError = async (error, title) => {
  const errorKeys = Object.getOwnPropertyNames(error);
  const formatted = errorKeys.reduce((acc, current, index) => (acc += `${errorKeys[index]}: ${error[current]}\n`), '');
  const indexOfStackTrace = formatted ? formatted.indexOf(`stackTrace: `) : -1;
  const msg = indexOfStackTrace >= 0 ? formatted.substr(0, indexOfStackTrace) : formatted;
  antdNotification['error']({
    description: msg && msg.split('\\n').map(msgText => <p>{msgText}</p>),
    message: title,
    duration: 10,
    style: {
      whiteSpace: 'pre-line'
    }
  });
};
const ErrorHandlerContext = createContext({ addError });

export const ErrorHandlerProvider = ErrorHandlerContext.Provider;

export function useErrorHandler() {
  const errorContext = useContext(ErrorHandlerContext);
  if (errorContext === null) {
    throw new Error('ErrorHandlerContext cannot be null, please add the context provider for ErrorHandlerContext');
  }
  return errorContext;
}
